import React from 'react';

import AppModal from '../../../ui-components/AppModal';
import AdminForm from './AdminForm';

interface AdminFormModalProps {
  isOpen: boolean;
  mode: 'create' | 'edit';
  adminId?: string;
  onClose: () => void;
  onSuccess?: () => void;
}

const AdminFormModal: React.FC<AdminFormModalProps> = ({
  isOpen,
  mode,
  adminId,
  onClose,
  onSuccess,
}) => {
  return (
    <AppModal
      isOpen={isOpen}
      title={mode === 'edit' ? 'Edit Admin' : 'Add Admin'}
      description={
        mode === 'create'
          ? 'Create a new Admin'
          : 'Update existing Admin information'
      }
      onClose={onClose}
      hideFooter
      variant="form"
      maxWidth="max-w-3xl"
      closeOnOverlayClick
    >
      <AdminForm
        embedded
        adminId={adminId}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </AppModal>
  );
};

export default AdminFormModal;
